export default {
    path: '/respond/ch/:id',
    name: 'form-response',
    props: { alternative: true },
    components: {
        alternative: () => import('@/views/respond/ch/[id].vue'),
    },
}
